import getConfig from 'next/config';
import { PromotionListClient } from 'types';

export const shouldDisplayContentfulContentByCountry = (
  targetingCountries: string[] = [],
  doctorProfile?: { country: string; [key: string]: any }
): boolean => {
  if (!doctorProfile || !doctorProfile.country) {
    return false;
  }

  // setup

  const doctorCountry = doctorProfile?.country.toUpperCase() ?? '';

  const upperCaseTargetingCountries = targetingCountries
    ? targetingCountries.map(country => country.toUpperCase())
    : [];

  // logic
  const countryNotSpecified = upperCaseTargetingCountries.length === 0;

  const countryIsMatching =
    upperCaseTargetingCountries.length > 0 &&
    upperCaseTargetingCountries.includes(doctorCountry);

  if (countryNotSpecified || countryIsMatching) {
    return true;
  }

  return false;
};

export const shouldDisplayContentfulContentByRegion = (
  targetingRegion = ''
): boolean => {
  // setup
  const { publicRuntimeConfig } = getConfig();

  const storeRegion = publicRuntimeConfig.STORE_REGION.toUpperCase();

  const regionIsMatching =
    targetingRegion.length > 0 && targetingRegion.toUpperCase() === storeRegion;

  if (regionIsMatching) {
    return true;
  }

  return false;
};

export const isRedeemEligibleUser = (data?: PromotionListClient): boolean => {
  if (!data) {
    return false;
  }

  const redeemPoints = data.redeemProductList?.length > 0;
  return redeemPoints;
};
